exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* TEXTFIELD */\n\n/* LIST */\n\n/* ==========  Layout  ========== */\n\n/* BUTTON */\n\n/* ANIMATION */\n\n/* Small control size */\n\n:host mdl-icon {\n  vertical-align: middle;\n  padding-left: 12px;\n  cursor: pointer;\n}\n\n:host .attachment-label {\n  font-weight: 800;\n  cursor: pointer;\n}\n\n", ""]);

// exports
